import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    users: {
      allUsers: [],
      isFetching: false,
      error: false,
    },
    create: {
      isFetching: false,
      error: false,
      success: false,
    },
  },
  reducers: {
    getUsersStart: (state) => {
      state.users.isFetching = true;
    },
    getUsersSuccess: (state, action) => {
      state.users.isFetching = false;
      state.users.allUsers = action.payload;
      state.users.error = false;
    },
    getUsersFailed: (state) => {
      state.users.isFetching = false;
      state.users.error = true;
    },
    createUserStart: (state) => {
      state.create.isFetching = true;
    },
    createUserSuccess: (state, action) => {
      state.create.isFetching = false;
      state.create.success = true;
      state.users.allUsers.push(action.payload);
    },
    createUserFailed: (state) => {
      state.create.isFetching = false;
      state.create.error = true;
      state.create.success = false;
    },
  },
});

export const {
  getUsersStart,
  getUsersSuccess,
  getUsersFailed,
  createUserStart,
  createUserSuccess,
  createUserFailed,
} = userSlice.actions;

export default userSlice.reducer;
